import * as React from 'react';
import { FormattedMessage } from "react-intl";
import Card from "../card/card";
import Share from "../share/share";
import './landingHero.scss';

import { Watch } from 'scrollmonitor-react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(faPlus);
 

class LandingHero extends React.Component {
    render() {
        let theBlock = this.props.block;
        let tmpArticle = [];
        let tmpArticles = [];
        let baseUrl = this.props.baseUrl ? this.props.baseUrl : ".";
        let inView = this.props.isInViewport;
        let elementHasBeenInView = this.props.isAboveViewport;
    
        // Change classname based on boolean
        let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
        let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

        //populate new article array with all article data
        if(theBlock.blockLinkedAsideArticles) {
            theBlock.blockLinkedAsideArticles.forEach(function(item) {
                let indexOfArticleData = this.props.issueArticles.map(function(o) { return o.articleId; }).indexOf(item.articleId);
                tmpArticles.push(this.props.issueArticles[indexOfArticleData]);
            }, this);
        }

        if(theBlock){
            tmpArticle = tmpArticles.map(function(article, key) {
                return (
                    <Card renderImage={true} key={"card_"+article.articleId+key} baseUrl={baseUrl} issueId={this.props.issueId} cardData={article} changeRoute={this.props.changeRoute} locale={this.props.locale}/>
                )
            }, this);
        }
        return (
        <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType + " " + this.props.fixedHeroClass : viewClassName + beenViewed + " " + theBlock.blockType + " " + this.props.fixedHeroClass}> 
            <div className="container"> 
                <div className="row">
                    <div className="col-12 mb-sm-4">
                        <div className="row">
                            <div className="col-md-8 sm-no-pad sticky-top">
                                <div className="is-image hero-image">
                                    <img src={baseUrl+theBlock.blockHeroImage} alt={theBlock.blockHeroImageAlt}/>
                                </div>
                                <div className="row sm-no-mar">
                                    <div className="col-md-10 col-lg-9 offset-md-1 offset-lg-2 sm-no-pad">
                                        <div className="heroIntroBoxOuter">
                                            <div className="heroIntroBox">
                                                <span className="issueId">{this.props.issueTitle}</span>
                                                {this.props.pageH1 ? <h1 className="issueTitle">{theBlock.blockTitle}</h1> : <h2 className="issueTitle h1">{theBlock.blockTitle}</h2> }
                                                <div className="issueSummary" dangerouslySetInnerHTML={{__html: theBlock.blockSummary}}/>
                                                <div className={theBlock.hideMoreButton ? "issueSummaryMore" : "issueSummaryMore collapse"} id={"moreid_"+this.props.issueId+"heroIntroBox"} dangerouslySetInnerHTML={{__html: theBlock.blockFooter}} />
                                            </div>
                                            <div className={theBlock.hideMoreButton ? "heroIntroBoxFooter without-more" : "heroIntroBoxFooter"}>
                                            {!theBlock.hideMoreButton &&
                                                <a className="btn btn-primary read-more in-page" data-toggle="collapse" href={"#moreid_"+this.props.issueId+"heroIntroBox"} role="button" aria-expanded="false" aria-controls={"moreid_"+this.props.issueId+"heroIntroBox"}>
                                                    {theBlock.moreButtonText === "" ? (<FormattedMessage id="General.readMore" defaultMessage="Read More" />) : (<span>{theBlock.moreButtonText}</span>)}
                                                    <span className="more-plus"><FontAwesomeIcon icon="plus" /></span>
                                                </a>
                                            }   
                                            <Share />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 offset-md-8 hero-right">
                                {tmpArticle}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}

export default Watch(LandingHero);
